import { joinURL } from 'ufo'

export const useStatamicPost = () => {
    const submit = async <T>(endpoint: string, data: []) => {
        const apiUrl = joinURL(useRuntimeConfig().public.statamicUrl, '/api')

        // first, we need to get a CSRF token
        await $fetch(joinURL(apiUrl, '/csrf-cookie'), {
            credentials: 'include',
        })

        const xsrfToken = useCookie('XSRF-TOKEN').value
        const headers: Record<string, string> = {}

        if (typeof xsrfToken === 'string') {
            headers['X-XSRF-TOKEN'] = xsrfToken
        }

        return $fetch<T>(joinURL(apiUrl, endpoint), {
            method: 'POST',
            body: data,
            credentials: 'include',
            headers,
        })
    }

    return {
        submit,
    }
}
